/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".detailed-toggle{margin:15px 0}  .detailed-toggle .mat-slide-toggle-content{font-size:.9rem;font-weight:600}  .detailed-toggle .mat-slide-toggle-content .info{line-height:15px;white-space:normal}.preview-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;-o-object-fit:contain;object-fit:contain;height:150px;border:1px solid #dde2ec;border-radius:5px;margin-bottom:20px}.veg-icon[_ngcontent-%COMP%]{width:20px;height:20px}"];
export { styles as styles };
